import request, { _POST } from "@/services/request";

/** 1-启用 2-禁用 */
export type AdminUserStatus = 1 | 2;

export type AdminUserItem = {
  participantId: string;
  mobile: string;
  name: string;
  headImg?: string;
  type?: number;
  channelId?: string;
  isAdmin?: boolean;
  status: AdminUserStatus;
  unionId?: string;
};

export type AdminUserListReq = {
  page?: number;
  pageSize?: number;
  mobile?: string;
  status?: AdminUserStatus;
};

export type AdminUserListRsp = {
  admins: AdminUserItem[];
  total: number;
};

export type AdminUserAddReq = {
  mobile: string;
  password?: string;
  headImg?: string;
  status?: AdminUserStatus;
};

export type AdminUserGetReq = {
  participantId: string;
};

export type AdminUserGetRsp = {
  admin: AdminUserItem;
};

export type AdminUserUpdateReq = {
  participantId: string;
  name?: string;
  headImg?: string;
  password?: string;
};

export type AdminUserUpdateStatusReq = {
  participantId: string;
  status: AdminUserStatus;
};

export type AdminUserDeleteReq = {
  participantId: string;
};

const listAdminUsers = (params?: AdminUserListReq) =>
  request<AdminUserListRsp, AdminUserListReq>(_POST, "/admin/adminUser/list")(params ?? {});

const addAdminUser = (params: AdminUserAddReq) =>
  request<{ admin: AdminUserItem; password?: string }, AdminUserAddReq>(_POST, "/admin/adminUser/add")(params);

const getAdminUser = (params: AdminUserGetReq) =>
  request<AdminUserGetRsp, AdminUserGetReq>(_POST, "/admin/adminUser/get")(params);

const updateAdminUser = (params: AdminUserUpdateReq) =>
  request<AdminUserGetRsp, AdminUserUpdateReq>(_POST, "/admin/adminUser/update")(params);

const updateAdminUserStatus = (params: AdminUserUpdateStatusReq) =>
  request<AdminUserGetRsp, AdminUserUpdateStatusReq>(_POST, "/admin/adminUser/updateStatus")(params);

const deleteAdminUser = (params: AdminUserDeleteReq) =>
  request<null, AdminUserDeleteReq>(_POST, "/admin/adminUser/delete")(params);

const adminUserApis = {
  listAdminUsers,
  addAdminUser,
  getAdminUser,
  updateAdminUser,
  updateAdminUserStatus,
  deleteAdminUser,
};

export default adminUserApis;
